import { ChevronRight, ExpandMore } from '@mui/icons-material'
import { TreeItem } from '@mui/x-tree-view/TreeItem'
import { TreeView } from '@mui/x-tree-view/TreeView'
import { useSidebar } from 'contexts/sidebar'
import { SyntheticEvent, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useStyles } from './styles'

const SidebarSub = () => {
  const [expandeds, setExpandeds] = useState<string[]>([])
  const [selecteds, setSelecteds] = useState<string[]>([])

  const { onCloseAll, selectedSubMenu } = useSidebar()

  const classes = useStyles()
  const history = useHistory()

  const items = selectedSubMenu.subMenuOptions || []

  const handleToggle = (_: SyntheticEvent, nodeIds: string[]) => setExpandeds(nodeIds)

  const handleSelect = (_: SyntheticEvent, nodeIds: string[]) => {
    setSelecteds(nodeIds)
    const selectedItem = items.find((item) => item.id === nodeIds[0])

    if (selectedItem && selectedItem.route) {
      history.push(selectedItem.route)
    }
  }

  console.log("KAJSHDA", items)

  const handleClickItem = (route: string) => {
    if (route) {
      history.push(route)
      onCloseAll()
    }
  }

  return (
    <nav className={classes.subRoot}>
      <div className={classes.subHeader}>
        <TreeView
          aria-label='file system navigator'
          defaultCollapseIcon={<ExpandMore />}
          defaultExpandIcon={<ChevronRight />}
          expanded={expandeds}
          selected={selecteds as any}
          onNodeToggle={handleToggle}
          onNodeSelect={handleSelect as any}
        >
          {items.length > 0 &&
            items.map(({ id, text, route, isOnlyApi }) => {
              if (isOnlyApi) {
                return null
              }

              return (
                <TreeItem
                  key={id}
                  nodeId={id}
                  label={text}
                  className={classes.item}
                  onClick={() => handleClickItem(route)}
                />
              )
            })}
        </TreeView>
      </div>
    </nav>
  )
}

export default SidebarSub
